import React from 'react';
import './SvodxLogo.css';

/* Знак SVODx по брендбуку (симметричный вариант): пять капсул, средняя — фиолетовая */
const BARS = [
    [19, 0, 58],
    [2, 20, 38],
    [0, 40, 27],
    [2, 60, 38],
    [19, 80, 58],
];

export function SvodxMark({ className = '', title }) {
    return (
        <svg className={`svodx-mark ${className}`.trim()} viewBox="0 0 77 92" role={title ? 'img' : undefined}
             aria-hidden={title ? undefined : true} focusable="false">
            {title && <title>{title}</title>}
            {BARS.map(([x, y, w], i) => (
                <rect key={y} x={x} y={y} width={w} height="12" rx="6" className={i === 2 ? 'svodx-mark__accent' : 'svodx-mark__bar'} />
            ))}
        </svg>
    );
}

/** Логотип: знак + «SVOD» + строчная «x» во втором акцентном цвете. */
export default function SvodxLogo({ className = '', withMark = true }) {
    return (
        <span className={`svodx-logo ${className}`.trim()}>
            {withMark && <SvodxMark />}
            <span className="svodx-logo__word">SVOD<span className="svodx-logo__x">x</span></span>
        </span>
    );
}
